import styled, { css } from "styled-components";

export const FooterContainer = styled.footer`
  position: relative;
  overflow: hidden;
  padding: 78px 0 30px;
  background: url("/images/fundo verde.jpg") no-repeat center center / cover;
  border-top: 0;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    z-index: 0;
    pointer-events: none;
    opacity: 0.2;
    background: repeating-linear-gradient(
      90deg,
      rgba(15, 143, 134, 0.11) 0,
      rgba(15, 143, 134, 0.11) 1px,
      transparent 1px,
      transparent 90px
    );
  }

  ${(props) =>
    props.$aesthetic
      ? css`
          padding: 72px 0 26px;
          border-top: 1px solid #d2e5d8;
          background: url("/images/fundo verde.jpg") no-repeat center center / cover;

          &::before {
            opacity: 0;
            background: none;
          }
        `
      : ""}
`;

export const FooterInner = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: none;
  margin: 0 auto;
  padding: 0 clamp(18px, 3.2vw, 42px);
  border-radius: 0;
  border: 0;
  background: transparent;
  backdrop-filter: none;
  box-shadow: none;

  ${(props) =>
    props.$aesthetic
      ? css`
          width: 100%;
          max-width: none;
          border-radius: 0;
          border: 0;
          background: transparent;
          backdrop-filter: none;
          box-shadow: none;
          padding: 0 clamp(18px, 3.8vw, 54px);
        `
      : ""}
`;

export const FooterTop = styled.div`
  padding: 0 0 34px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.36);
  display: grid;
  grid-template-columns: 1.2fr 0.8fr;
  gap: 36px;

  @media (max-width: 980px) {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  ${(props) =>
    props.$aesthetic
      ? css`
          grid-template-columns: 1.15fr 0.85fr;
          gap: 36px;
          border-bottom: 1px solid rgba(255, 255, 255, 0.36);

          @media (max-width: 980px) {
            grid-template-columns: 1fr;
          }
        `
      : ""}
`;

export const FooterBrand = styled.div``;

export const FooterTitle = styled.h3`
  margin: 0;
  color: #ffffff;
  font-family: "Space Grotesk", "IBM Plex Sans", "Avenir Next", sans-serif;
  font-size: clamp(1.16rem, 1.82vw, 1.5rem);
  line-height: 1.1;
  text-transform: uppercase;
  letter-spacing: -0.02em;

  ${(props) =>
    props.$aesthetic
      ? css`
          font-size: clamp(1.12rem, 1.8vw, 1.48rem);
          color: #ffffff;
        `
      : ""}
`;

export const FooterText = styled.p`
  margin: 10px 0 0;
  color: rgba(244, 251, 247, 0.92);
  font-size: 0.74rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;

  ${(props) =>
    props.$aesthetic
      ? css`
          color: rgba(244, 251, 247, 0.92);
        `
      : ""}
`;

export const FooterPhone = styled.button`
  margin-top: 18px;
  border: 1px solid rgba(255, 255, 255, 0.36);
  background: rgba(6, 22, 14, 0.18);
  padding: 10px 14px;
  min-height: auto;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #ffffff;
  cursor: pointer;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  transition: background 0.2s ease, color 0.2s ease, transform 0.2s ease;

  :hover {
    background: rgba(6, 22, 14, 0.3);
    color: #ffffff;
    transform: translateY(-1px);
  }

  ${(props) =>
    props.$aesthetic
      ? css`
          border: 1px solid rgba(255, 255, 255, 0.36);
          background: rgba(6, 22, 14, 0.18);
          border-radius: 999px;
          padding: 9px 13px;
          box-shadow: none;
          backdrop-filter: none;
          color: #ffffff;

          :hover {
            transform: translateY(-1px);
            background: rgba(6, 22, 14, 0.3);
            color: #ffffff;
          }
        `
      : ""}
`;

export const FooterColumns = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;

  @media (max-width: 620px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

export const FooterColumn = styled.div`
  padding: 0;
`;

export const FooterColumnTitle = styled.div`
  color: rgba(244, 251, 247, 0.86);
  font-size: 0.68rem;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  font-weight: 700;
  margin-bottom: 8px;
  opacity: 0.95;

  ${(props) =>
    props.$aesthetic
      ? css`
          color: rgba(244, 251, 247, 0.86);
        `
      : ""}
`;

export const FooterLink = styled.button`
  width: 100%;
  border: 0;
  background: transparent;
  padding: 10px 0;
  text-align: left;
  color: rgba(245, 252, 248, 0.92);
  font-size: 0.78rem;
  font-weight: 500;
  letter-spacing: 0.11em;
  text-transform: uppercase;
  cursor: pointer;
  border-top: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.28);
  transition: color 0.2s ease, transform 0.2s ease, background 0.2s ease;

  :hover {
    color: #ffffff;
    transform: translateX(3px);
    background: transparent;
  }

  ${(props) =>
    props.$aesthetic
      ? css`
          color: rgba(245, 252, 248, 0.92);
          border-bottom: 1px solid rgba(255, 255, 255, 0.28);
          transition: color 0.2s ease, transform 0.2s ease, background 0.2s ease;

          :hover {
            color: #ffffff;
            transform: none;
            background: transparent;
          }
        `
      : ""}
`;

export const FooterBottom = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  gap: 14px;
  justify-content: ${(props) => (props.$compact ? "flex-end" : "space-between")};
  align-items: center;

  @media (max-width: 860px) {
    flex-direction: column;
  }
`;

export const FooterSwitch = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 4px;
  border-radius: 999px;
  background: rgba(6, 22, 14, 0.18);
  border: 1px solid rgba(255, 255, 255, 0.36);

  ${(props) =>
    props.$aesthetic
      ? css`
          border-radius: 999px;
          background: rgba(6, 22, 14, 0.18);
          border: 1px solid rgba(255, 255, 255, 0.36);
          backdrop-filter: none;
        `
      : ""}
`;

export const FooterSwitchButton = styled.button`
  min-height: 40px;
  border: 0;
  border-radius: 999px;
  padding: 0 12px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #ffffff;
  background: ${(props) =>
    props.$active
      ? "linear-gradient(120deg, #0f8f86 0%, #2db8ae 100%)"
      : "transparent"};
  transition: opacity 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;

  :hover {
    transform: translateY(-1px);
    opacity: 0.92;
    box-shadow: ${(props) => (props.$active ? "0 12px 22px rgba(15, 143, 134, 0.28)" : "none")};
  }

  ${(props) =>
    props.$aesthetic
      ? css`
          border-radius: 999px;
          background: ${props.$active ? "rgba(6, 22, 14, 0.34)" : "transparent"};
          border: 1px solid ${props.$active ? "rgba(255, 255, 255, 0.45)" : "rgba(255, 255, 255, 0.28)"};
          color: #ffffff;

          :hover {
            transform: translateY(-1px);
            opacity: 0.92;
            box-shadow: none;
          }
        `
      : ""}
`;

export const FooterSwitchIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
`;

export const FooterSwitchLabel = styled.span`
  letter-spacing: 0.01em;
`;

export const FooterCopyright = styled.button`
  border: 0;
  background: transparent;
  color: rgba(244, 251, 247, 0.9);
  font-size: 0.72rem;
  font-weight: 500;
  letter-spacing: 0.13em;
  text-transform: uppercase;
  cursor: pointer;
  transition: opacity 0.2s ease;

  :hover {
    opacity: 0.78;
  }

  ${(props) =>
    props.$aesthetic
      ? css`
          color: rgba(244, 251, 247, 0.9);
        `
      : ""}
`;
